import { useEffect, useState } from 'react';

import { EnumOption } from '../../modules/types/types';
import httpClient, { isHttpCancel } from '../httpClient';

export const useUnidadeDAF = () => {
  const [unidadeDAF, setUnidadeDAF] = useState<EnumOption[]>([]);

  useEffect(() => {
    const controller = new AbortController();

    const fetchUnidadeDAF = async () => {
      try {
        const response = await httpClient.get(`/api/users/unidadedaf`, {
          signal: controller.signal,
        });

        const options = response.data.map(
          (unidadeDAF: { value: number; label: string }) => ({
            value: unidadeDAF.value.toString(),
            label: unidadeDAF.label,
          }),
        );

        setUnidadeDAF(options);
      } catch (error: any) {
        if (isHttpCancel(error) || error.name === 'CanceledError') {
          // console.log('Requisição de Unidade DAF cancelada.');
        } else {
          console.warn('Erro ao buscar Unidades DAF:', error);
          setUnidadeDAF([]);
        }
        // console.warn('Erro ao buscar Unidades DAF:', error);
        setUnidadeDAF([]);
      }
    };

    fetchUnidadeDAF();

    return () => {
      controller.abort();
    };
  }, []);

  return unidadeDAF;
};
//eslint-disable-next-line
